/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AuditInfoDto {
  /** @example "system" */
  createdBy?: string;
  /** @format date-time */
  createdDate?: string;
  /** @example "system" */
  lastModifiedBy?: string;
  /** @format date-time */
  lastModifiedDate?: string;
  /**
   * @format int64
   * @example 1
   */
  version?: number;
}

export interface CustomerProjectionDto {
  /** @format uuid */
  customerId?: string;
  customerNumber?: string;
  displayName?: string;
  name?: string;
}

export interface FieldValidationDto {
  code?: string;
  field?: string;
  message?: string;
}

export interface PlacementProcessProjectionDto {
  correlationId?: string;
  /** @format uuid */
  customerId?: string;
  /** @format uuid */
  id?: string;
  /** @format uuid */
  processId?: string;
  username?: string;
}

export interface PreservationMessageDto {
  code?: string;
  /** @format date-time */
  createdDate?: string;
  documentId?: string;
  message?: string;
  type?: PreservationTypeDto;
}

export enum PreservationTypeDto {
  COC = "COC",
  ZB1 = "ZB1",
  ZB2 = "ZB2",
  ABE = "ABE",
  CERT = "CERT",
  CONTRACT = "CONTRACT",
  SALARY_STATEMENT = "SALARY_STATEMENT",
  ID_CARD = "ID_CARD",
  OTHER = "OTHER",
  CAR_KEY = "CAR_KEY",
  LICENSE_PLATE_FRONT = "LICENSE_PLATE_FRONT",
  LICENSE_PLATE_REAR = "LICENSE_PLATE_REAR",
  WARRANTY = "WARRANTY",
  RADIO_CODE = "RADIO_CODE",
}

export interface ResourceCreatedDto {
  /** @format uuid */
  id?: string;
}

export enum SortTypeDto {
  ASC = "ASC",
  DESC = "DESC",
}

export interface ValidationDto {
  fields?: FieldValidationDto[];
}

export interface VehicleDataAcquisitionDataDto {
  /**
   * CMS Kunden id
   * @format uuid
   */
  customerId: string;
  /**
   * Dokumente für die Erfassung eines Fahrzeuges
   * @minItems 1
   */
  documents: VehicleDataAcquisitionDocumentDto[];
  /**
   * Einlagerungsprozess-Id
   * @format uuid
   */
  placementProcessId: string;
  status?: VehicleDataAcquisitionStatusDto;
  /**
   * Fahrgestellnummer
   * @minLength 1
   * @pattern ^((?![IOQ])[A-Z0-9]){17}$
   */
  vin: string;
  /** Prüfziffer der Fahrgestellnummer */
  vinCheckDigit?: string;
}

export interface VehicleDataAcquisitionDetailDto {
  audit?: AuditInfoDto;
  data: VehicleDataAcquisitionDataDto;
}

export interface VehicleDataAcquisitionDocumentAbeDto {
  /**
   * Document id of CoC document
   * @minLength 1
   */
  documentId: string;
  /**
   * Position of document within stack
   * @format int64
   */
  position: number;
  /** @default "ABE" */
  type?: string;
}

export interface VehicleDataAcquisitionDocumentCarKeyDto {
  /**
   * Document id of document
   * @minLength 1
   */
  documentId: string;
  /** Note for car key - default is vehicle license plate */
  note?: string;
  /**
   * Position of document within stack
   * @format int64
   */
  position: number;
  /** @default "CAR_KEY" */
  type?: string;
}

export interface VehicleDataAcquisitionDocumentCertDto {
  /**
   * Document id of CoC document
   * @minLength 1
   */
  documentId: string;
  /**
   * Position of document within stack
   * @format int64
   */
  position: number;
  /** @default "CERT" */
  type?: string;
}

export interface VehicleDataAcquisitionDocumentCocDto {
  /**
   * Document id of CoC document
   * @minLength 1
   */
  documentId: string;
  /**
   * Position of document within stack
   * @format int64
   */
  position: number;
  /** @default "COC" */
  type?: string;
}

export interface VehicleDataAcquisitionDocumentContractDto {
  /**
   * Document id of CoC document
   * @minLength 1
   */
  documentId: string;
  /**
   * Position of document within stack
   * @format int64
   */
  position: number;
  /** @default "CONTRACT" */
  type?: string;
}

export interface VehicleDataAcquisitionDocumentCor1Dto {
  /**
   * ZB1 Nummer
   * @minLength 1
   * @pattern ^[A-Z][0-9A-ZÄÖÜ\-/]{17,19}$
   */
  corSerial: string;
  /**
   * Abmeldedatum
   * @format date
   */
  deregistrationDate?: string;
  /**
   * Document id of certificate of registration (part 1) document
   * @minLength 1
   */
  documentId: string;
  /** aktuelles Kennzeichen (keine Pflicht- da bei Neufahrzeugen nicht gefüllt) */
  licensePlate?: string;
  /**
   * Position of document within stack
   * @format int64
   */
  position: number;
  /**
   * Erstzulassungsdatum (keine Pflicht- da bei Neufahrzeugen nicht gefüllt)
   * @format date
   */
  registrationDateFirst?: string;
  /**
   * aktuelles Zulassungsdatum (keine Pflicht- da nicht immer gefüllt)
   * @format date
   */
  registrationDateLatest?: string;
  /** @default "COR_I" */
  type?: string;
}

export interface VehicleDataAcquisitionDocumentCor2Dto {
  /**
   * ZB2 Nummer
   * @minLength 1
   * @pattern ^[A-Z]{2}[0-9]{6}$
   */
  corNumber: string;
  /**
   * Document id of certificate of registration (part 2) document
   * @minLength 1
   */
  documentId: string;
  /** aktuelles Kennzeichen (keine Pflicht- da bei Neufahrzeugen nicht gefüllt) */
  licensePlate?: string;
  /**
   * Position of document within stack
   * @format int64
   */
  position: number;
  /**
   * Erstzulassungsdatum (keine Pflicht- da bei Neufahrzeugen nicht gefüllt)
   * @format date
   */
  registrationDateFirst?: string;
  /**
   * aktuelles Zulassungsdatum (keine Pflicht- da nicht immer gefüllt)
   * @format date
   */
  registrationDateLatest?: string;
  /** @default "COR_II" */
  type?: string;
}

export type VehicleDataAcquisitionDocumentDto = BaseVehicleDataAcquisitionDocumentDto &
  (
    | BaseVehicleDataAcquisitionDocumentDtoTypeMapping<"ABE", VehicleDataAcquisitionDocumentAbeDto>
    | BaseVehicleDataAcquisitionDocumentDtoTypeMapping<"CAR_KEY", VehicleDataAcquisitionDocumentCarKeyDto>
    | BaseVehicleDataAcquisitionDocumentDtoTypeMapping<"CERT", VehicleDataAcquisitionDocumentCertDto>
    | BaseVehicleDataAcquisitionDocumentDtoTypeMapping<"COC", VehicleDataAcquisitionDocumentCocDto>
    | BaseVehicleDataAcquisitionDocumentDtoTypeMapping<"CONTRACT", VehicleDataAcquisitionDocumentContractDto>
    | BaseVehicleDataAcquisitionDocumentDtoTypeMapping<"COR_I", VehicleDataAcquisitionDocumentCor1Dto>
    | BaseVehicleDataAcquisitionDocumentDtoTypeMapping<"COR_II", VehicleDataAcquisitionDocumentCor2Dto>
    | BaseVehicleDataAcquisitionDocumentDtoTypeMapping<"ID_CARD", VehicleDataAcquisitionDocumentIdCardDto>
    | BaseVehicleDataAcquisitionDocumentDtoTypeMapping<
        "LICENSE_PLATE_FRONT",
        VehicleDataAcquisitionDocumentLicensePlateFrontDto
      >
    | BaseVehicleDataAcquisitionDocumentDtoTypeMapping<
        "LICENSE_PLATE_REAR",
        VehicleDataAcquisitionDocumentLicensePlateRearDto
      >
    | BaseVehicleDataAcquisitionDocumentDtoTypeMapping<"OTHER", VehicleDataAcquisitionDocumentOtherDto>
    | BaseVehicleDataAcquisitionDocumentDtoTypeMapping<"RADIO_CODE", VehicleDataAcquisitionDocumentRadioCodeDto>
    | BaseVehicleDataAcquisitionDocumentDtoTypeMapping<
        "SALARY_STATEMENT",
        VehicleDataAcquisitionDocumentSalaryStatementDto
      >
    | BaseVehicleDataAcquisitionDocumentDtoTypeMapping<"WARRANTY", VehicleDataAcquisitionDocumentWarrantyDto>
  );

export interface VehicleDataAcquisitionDocumentIdCardDto {
  /**
   * Document id of CoC document
   * @minLength 1
   */
  documentId: string;
  /**
   * Position of document within stack
   * @format int64
   */
  position: number;
  /** @default "ID_CARD" */
  type?: string;
}

export interface VehicleDataAcquisitionDocumentLicensePlateFrontDto {
  /**
   * Document id of document
   * @minLength 1
   */
  documentId: string;
  /**
   * License Plate
   * @minLength 1
   */
  licensePlate: string;
  /**
   * Position of document within stack
   * @format int64
   */
  position: number;
  /** @default "LICENSE_PLATE_FRONT" */
  type?: string;
}

export interface VehicleDataAcquisitionDocumentLicensePlateRearDto {
  /**
   * Document id of document
   * @minLength 1
   */
  documentId: string;
  /**
   * License Plate
   * @minLength 1
   */
  licensePlate: string;
  /**
   * Position of document within stack
   * @format int64
   */
  position: number;
  /** @default "LICENSE_PLATE_REAR" */
  type?: string;
}

export interface VehicleDataAcquisitionDocumentOtherDto {
  /**
   * Document id of CoC document
   * @minLength 1
   */
  documentId: string;
  /**
   * Position of document within stack
   * @format int64
   */
  position: number;
  /** @default "OTHER" */
  type?: string;
}

export interface VehicleDataAcquisitionDocumentRadioCodeDto {
  /**
   * Document id of document
   * @minLength 1
   */
  documentId: string;
  /**
   * Position of document within stack
   * @format int64
   */
  position: number;
  /** @default "RADIO_CODE" */
  type?: string;
}

export interface VehicleDataAcquisitionDocumentSalaryStatementDto {
  /**
   * Document id of CoC document
   * @minLength 1
   */
  documentId: string;
  /**
   * Position of document within stack
   * @format int64
   */
  position: number;
  /** @default "SALARY_STATEMENT" */
  type?: string;
}

export interface VehicleDataAcquisitionDocumentWarrantyDto {
  /**
   * Document id of document
   * @minLength 1
   */
  documentId: string;
  /**
   * Position of document within stack
   * @format int64
   */
  position: number;
  /** @default "WARRANTY" */
  type?: string;
}

export interface VehicleDataAcquisitionEventDto {
  audit: AuditInfoDto;
  data: VehicleDataAcquisitionDataDto;
  /**
   * VehicleDataAcquisition ID
   * @format uuid
   */
  id: string;
}

export interface VehicleDataAcquisitionListDto {
  items?: VehicleDataAcquisitionListItemDto[];
  /** @format int32 */
  totalPages?: number;
}

export interface VehicleDataAcquisitionListItemDto {
  /** @format date-time */
  createdDate?: string;
  customer?: string;
  /** @format uuid */
  id?: string;
  status?: VehicleDataAcquisitionStatusDto;
  vin?: string;
}

/** Columns available for sorting */
export enum VehicleDataAcquisitionSortByDto {
  LAST_MODIFIED = "LAST_MODIFIED",
}

export enum VehicleDataAcquisitionStatusDto {
  ACQUISITION = "ACQUISITION",
  TRANSFER = "TRANSFER",
  ERROR = "ERROR",
  COMPLETED = "COMPLETED",
}

interface BaseVehicleDataAcquisitionDocumentDto {
  type: string;
}

type BaseVehicleDataAcquisitionDocumentDtoTypeMapping<Key, Type> = {
  type: Key;
} & Type;

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "/";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Vehicle Data Acquisition Service by Kroschke
 * @version 0.1
 * @baseUrl /
 */
export class Vda<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Acquisition
     * @name ListVehicleDataAcquisition
     * @summary Returns a list of vehicle data acquisitions
     * @request GET:/api/v1/acquisition/vehicle
     * @secure
     */
    listVehicleDataAcquisition: (
      query?: {
        /**
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * @format int32
         * @min 0
         * @exclusiveMin true
         * @default 25
         */
        size?: number;
        /** Columns available for sorting */
        sortBy?: VehicleDataAcquisitionSortByDto;
        sortType?: SortTypeDto;
        q?: string;
        /**
         * One hour
         * @example "PT1H"
         */
        fromRelative?: string;
        /**
         * One day
         * @example "P1D"
         */
        toRelative?: string;
        /** @format date-time */
        fromAbsolute?: string;
        /** @format date-time */
        toAbsolute?: string;
        /** @format uuid */
        customerId?: string;
        /** @uniqueItems true */
        status?: VehicleDataAcquisitionStatusDto[];
      },
      params: RequestParams = {},
    ) =>
      this.request<VehicleDataAcquisitionListDto, any>({
        path: `/api/v1/acquisition/vehicle`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Acquisition
     * @name CreateVehicleDataAcquisition
     * @summary Creates a new vehicle data acquisition
     * @request POST:/api/v1/acquisition/vehicle
     * @secure
     */
    createVehicleDataAcquisition: (data: VehicleDataAcquisitionDataDto, params: RequestParams = {}) =>
      this.request<ResourceCreatedDto, any>({
        path: `/api/v1/acquisition/vehicle`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Acquisition
     * @name ValidateVehicleDataAcquisition
     * @summary Validates vehicle data acquisition
     * @request POST:/api/v1/acquisition/vehicle/validation
     * @secure
     */
    validateVehicleDataAcquisition: (data: VehicleDataAcquisitionDataDto, params: RequestParams = {}) =>
      this.request<ValidationDto, any>({
        path: `/api/v1/acquisition/vehicle/validation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Acquisition
     * @name GetVehicleDataAcquisition
     * @summary Get vehicle data acquisition detail data
     * @request GET:/api/v1/acquisition/vehicle/{id}
     * @secure
     */
    getVehicleDataAcquisition: (id: string, params: RequestParams = {}) =>
      this.request<VehicleDataAcquisitionDetailDto, any>({
        path: `/api/v1/acquisition/vehicle/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Acquisition
     * @name UpdateVehicleDataAcquisition
     * @summary Update vehicle data acquisition
     * @request POST:/api/v1/acquisition/vehicle/{id}
     * @secure
     */
    updateVehicleDataAcquisition: (id: string, data: VehicleDataAcquisitionDetailDto, params: RequestParams = {}) =>
      this.request<VehicleDataAcquisitionDetailDto, any>({
        path: `/api/v1/acquisition/vehicle/${id}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Acquisition
     * @name GetPreservationMessages
     * @summary Lists all messages created by VRS during preservation process
     * @request GET:/api/v1/acquisition/vehicle/{id}/message
     * @secure
     */
    getPreservationMessages: (id: string, params: RequestParams = {}) =>
      this.request<PreservationMessageDto[], any>({
        path: `/api/v1/acquisition/vehicle/${id}/message`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Acquisition
     * @name ReopenVehicleDataAcquisition
     * @summary Set vehicle data acquisition status to 'transfer' to initialize data transfer
     * @request POST:/api/v1/acquisition/vehicle/{id}/reopen
     * @secure
     */
    reopenVehicleDataAcquisition: (id: string, params: RequestParams = {}) =>
      this.request<VehicleDataAcquisitionDetailDto, any>({
        path: `/api/v1/acquisition/vehicle/${id}/reopen`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Acquisition
     * @name TransferVehicleDataAcquisition
     * @summary Set vehicle data acquisition status to 'transfer' to initialize data transfer
     * @request POST:/api/v1/acquisition/vehicle/{id}/transfer
     * @secure
     */
    transferVehicleDataAcquisition: (id: string, params: RequestParams = {}) =>
      this.request<VehicleDataAcquisitionDetailDto, any>({
        path: `/api/v1/acquisition/vehicle/${id}/transfer`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer Projection
     * @name FindCustomers
     * @summary Find first 50 active customers
     * @request GET:/api/v1/projection/customer
     * @secure
     */
    findCustomers: (
      query?: {
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerProjectionDto[], any>({
        path: `/api/v1/projection/customer`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Placement Process Projection
     * @name ListCustomerPlacementProcesses
     * @summary Find all active placement processes for customer
     * @request GET:/api/v1/projection/placement
     * @secure
     */
    listCustomerPlacementProcesses: (
      query: {
        /** @format uuid */
        customerId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PlacementProcessProjectionDto[], any>({
        path: `/api/v1/projection/placement`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Placement Process Projection
     * @name GetPlacementProcess
     * @summary Get placement process by id
     * @request GET:/api/v1/projection/placement/{id}
     * @secure
     */
    getPlacementProcess: (id: string, params: RequestParams = {}) =>
      this.request<PlacementProcessProjectionDto, any>({
        path: `/api/v1/projection/placement/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
